import { ComponentRef, Directive, inject, Input, OnChanges, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Field, FieldAttribute } from '../../../interfaces/form-and-field.interface';
import { AllowedFormFieldsService } from './allowed-form-fields.service';

@Directive({
  selector: '[dynamicField]',
})
export class FieldConstructorDirective implements Field, OnChanges, OnInit, OnDestroy {
  @Input({ required: true }) public fieldAttribute: FieldAttribute;
  @Input({ required: true }) public form: UntypedFormGroup;

  public component: ComponentRef<Field>;

  private allowedFieldsService = inject(AllowedFormFieldsService);
  private container = inject(ViewContainerRef);

  public ngOnChanges(): void {
    this.updateComponent();
  }

  public ngOnInit(): void {
    this.createComponent();
  }

  public ngOnDestroy(): void {
    if (this.component) {
      this.component.destroy();
    }
  }

  private createComponent(): void {
    if (!this.allowedFieldsService.isNotAllowedField(this.fieldAttribute)) {
      this.component = this.container.createComponent(this.allowedFieldsService.getComponent(this.fieldAttribute));
    }

    this.updateComponent();
  }

  private updateComponent(): void {
    if (this.component) {
      this.component.instance.fieldAttribute = this.fieldAttribute;
      this.component.instance.form = this.form;
    }
  }
}
